import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import QuestionnaireChip from '../questionnaireChip';

const useStyles = makeStyles(({ spacing }) => ({
  label: {
    marginBottom: spacing(2),
  },
}));

const Questionnaire = ({ label, name = '' }) => {
  const classes = useStyles();

  return (
    <div>
      {label && (
        <Typography variant="subtitle2" className={classes.label}>
          {label}
        </Typography>
      )}
      <QuestionnaireChip name={name} />
    </div>
  );
};

Questionnaire.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default Questionnaire;
